
















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import bus from '@/core/bus';
import { ClientMessage, ValidationErrorEvent, ValidationErrorEventKey } from '@/core/messages/types';
import dictionaryService from '@/core/translation/dictionary.service';

@Component
export default class WebApiMessage extends Vue {
    private messages: ClientMessage[] = [];
    private errorId: string = '';
    @Prop({
        required: true
    })
    private id!: string;

    private created() {
        bus.on(ValidationErrorEventKey, this.onMessages);
    }

    private onMessages(validationErrorEvent: ValidationErrorEvent) {
        if (validationErrorEvent.messagesId === this.id) {
            this.messages = validationErrorEvent.messages;
            this.errorId = validationErrorEvent.errorId;
            validationErrorEvent.handled();
        }
    }

    private getMessage(msgOrLabel: string): string {
        if (dictionaryService.exists(msgOrLabel)) {
            return dictionaryService.get(msgOrLabel);
        }
        return msgOrLabel;
    }

    private destroyed() {
        bus.off(ValidationErrorEventKey, this.onMessages);
    }
}
